import React from "react";
import { ConditionDescriptions } from "./ConditionDescriptions";

interface ConditionCardContentProps {
  title: string;
  internal_description?: string;
  external_description?: string;
}

export function ConditionCardContent({
  title,
  internal_description,
  external_description,
}: ConditionCardContentProps) {
  return (
    <div className="min-w-0 flex-1">
      <div className="mb-1.5">
        <p className="font-medium text-[#101827]">{title}</p>
      </div>
      <ConditionDescriptions
        internal_description={internal_description}
        external_description={external_description}
      />
    </div>
  );
}
